import { get } from "lodash";
import { useState } from "react";
import Button from "../Components/Button";
import Header from "../Components/Header";
import Needs from "./Needs";
import Levels from "./Levels";
import ActionButtons from "../Components/ActionButtons";
import Layout from "../Components/Layout";
import { Col, Drawer, Row } from "antd";
import { useMediaQuery } from "react-responsive";
import { MdClose } from "react-icons/md";

function View({ fields, onNext, onBack, categories }) {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const [selectedValues, setSelectedValues] = useState(
    categories.reduce((acc, category) => {
      acc[category.value] = get(fields, `needs.${category.value}`, 1);
      return acc;
    }, {})
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Layout>
      <Header
        title="Quels sont vos besoins ?"
        highlight="besoins"
        subtitle="Personnalisation de votre couverture"
        onBack={onBack}
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={12}>
          <Needs
            categories={categories}
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onClick={() => setDrawerVisible(true)}
          />
        </Col>
      </Row>

      <ActionButtons
        onNext={() =>
          onNext({
            payload: {
              fields: {
                ...fields,
                budget: { min: 0, max: 1000 },
                needs: selectedValues,
              },
            },
          })}
        onBack={onBack}
      />

      <Drawer
        placement="right"
        className="amellis__drawer right--drawer"
        closable
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={isMobile ? "98%" : "50%"}
      >
        <div className="drawer__wrapper">
          <div className="drawer__wrapper--header">
            <div className="title">
              <h3>Les niveaux de remboursement</h3>
            </div>
            <p>Chaque niveau correspond à des choix spécifiques concernant les professionnels de santé consultés et le niveau de remboursement souhaité. Voici une présentation des différents niveaux de besoins en santé :</p>
          </div>
          <Levels />
          <Button
            type={"default"}
            onClick={() => {
              setDrawerVisible(false);
            }}>
            Fermer
          </Button>
        </div>
      </Drawer>

    </Layout>
  );
}

export default View;
